module.exports = __webpack_public_path__ + "img/ppt.8b3549a5.svg";